import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideConfig, SiteContextModule } from '@spartacus/core'
import { IconModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../guards/user-permissions.guard'
import { SharedModule } from '../../shared/shared.module'
import { AccountSummaryModule } from '../account-summary.module'
import { CustomSiteContextSelectorComponent } from './custom-site-context-selector.component'

@NgModule({
  imports: [CommonModule, RouterModule, SiteContextModule, IconModule, AccountSummaryModule, FormsModule, SharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSSiteContextComponent: {
          component: CustomSiteContextSelectorComponent,
          guards: [UserPermissionsGuard]
        }
      }
    })
  ],
  declarations: [CustomSiteContextSelectorComponent],
  exports: [CustomSiteContextSelectorComponent]
})
export class SiteContextSelectorModule {}
